import { addMutator } from '@poa/state';

import {
  fetchCredList,
  fetchUserCredList,
  fetchCredListSuccess,
  fetchCredListFailed,
  refreshAccounts,
  fetchAccountsSuccess,
  fetchAccountsFailed,
  fetchUsers,
  fetchUsersSuccess,
  fetchUsersFailed,
  fetchMsgs,
  fetchMsgsSuccess,
  fetchMsgsFailed,
  saveChatJson
} from './chats.actions';


// fetch
addMutator(fetchCredList, (_, { store }) => {
  store.chats.meta.hasError = false;
  store.chats.is_loading = true;
});

addMutator(fetchUserCredList, (_, { store }) => {
  store.chats.meta.hasError = false;
  store.chats.is_loading = true;
});

addMutator(fetchCredListSuccess, ({ data }, { store }) => {
  store.chats.meta.hasError = false;
  store.chats.cred_list.replace(data);
  store.chats.selected_cred_id = {value: data[0].id, label: data[0].title};
  store.chats.is_loading = false;
});

addMutator(fetchCredListFailed, (_, { store }) => {
  store.chats.meta.hasError = true;
  store.chats.cred_list.replace([]);
  store.chats.is_loading = false;
});

addMutator(refreshAccounts, (_, { store }) => {
  store.chats.accounts_meta.isLoading = true;
  store.chats.accounts_meta.hasError = false;
});

addMutator(fetchAccountsSuccess, ({ data }, { store }) => {
  store.chats.accounts_meta.isLoading = false;
  store.chats.accounts_meta.hasError = false;

  let accounts = [];

  if (data.data) {
      accounts = data.data[0].tbody;
  } else {
      accounts = data[0].tbody;
  }

  accounts = accounts.map((account) => {
    return {
      id: account.id,
      full_name: account.section_1.full_name.value,
      nick: account.section_2.nick.value,
      avatar: account.section_1.photo.value
    };
  });
  store.chats.account_list.replace(accounts);
  store.chats.accounts_meta.loaded = true;
});

addMutator(fetchAccountsFailed, (payload, { store }) => {
  store.chats.accounts_meta.isLoading = false;
  store.chats.accounts_meta.hasError = true;
});


addMutator(fetchUsers, (_, { store }) => {
  store.chats.users_meta.hasError = false;
  store.chats.users_meta.isLoading = true;
  store.chats.users_meta.loaded = false;
});


addMutator(saveChatJson, (_, { store }) => {
  console.log('Saving chat JSON...');
});


addMutator(fetchUsersSuccess, ({ data }, { store }) => {
  store.chats.users_meta.hasError = false;
  store.chats.users_meta.isLoading = false;
  store.chats.users_list.replace(data.users);
  store.chats.users_meta.loaded = true;
});

addMutator(fetchUsersFailed, (_, { store }) => {
  store.chats.users_meta.hasError = true;
  store.chats.users_meta.loaded = true;
  store.chats.users_meta.isLoading = false;
});


addMutator(fetchMsgs, (_, { store }) => {
  store.chats.chat_meta.hasError = false;
  store.chats.chat_meta.isLoading = true;
  store.chats.chat_meta.loaded = false;
});


addMutator(fetchMsgsSuccess, ({ data }, { store }) => {
  store.chats.chat_meta.hasError = false;
  store.chats.chat_meta.isLoading = false;
  store.chats.chat_list.replace(data.data.messages);
  store.chats.chat_meta.loaded = true;
});

addMutator(fetchMsgsFailed, (_, { store }) => {
  store.chats.chat_meta.hasError = true;
  store.chats.chat_meta.loaded = true;
  store.chats.chat_meta.isLoading = false;
});
